<!-- src\components\admin\layout\AdminSidebarCollapsed.vue -->
<template>
	<aside class="admn_sidebar-collapsed">
		<!-- Логотип -->
		<div class="admn_sidebar-logo">
			<img
				src="/logo-metall-treid.png"
				alt="Logo"
			/>
		</div>

		<!-- Разделитель -->
		<div class="admn_sidebar-divider"></div>

		<!-- Меню навигации -->
		<nav class="admn_sidebar-nav">
			<!-- 1. Главная (Дашборд) -->
			<button
				v-if="showDashboardSection"
				:class="['admn_nav-item', { active: activeMenu === 1 }]"
				@click="setActiveMenu(1)"
				title="Дашборд"
			>
				<svg width="24" height="24" viewBox="0 0 27 27" fill="none">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M13.5 5.55694L23.625 15.6819V22.7812C23.625 23.4526 23.3583 24.0964 22.8836 24.5711C22.4089 25.0458 21.7651 25.3125 21.0938 25.3125H5.90625C5.23492 25.3125 4.59109 25.0458 4.11639 24.5711C3.64168 24.0964 3.375 23.4526 3.375 22.7812V15.6819L13.5 5.55694ZM21.9375 4.21875V10.125L18.5625 6.75V4.21875C18.5625 3.99497 18.6514 3.78036 18.8096 3.62213C18.9679 3.4639 19.1825 3.375 19.4062 3.375H21.0938C21.3175 3.375 21.5321 3.4639 21.6904 3.62213C21.8486 3.78036 21.9375 3.99497 21.9375 4.21875Z"
						fill="currentColor"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12.308 2.53119C12.6245 2.21483 13.0536 2.03711 13.5011 2.03711C13.9485 2.03711 14.3777 2.21483 14.6941 2.53119L25.9109 13.7463C26.0694 13.9047 26.1584 14.1196 26.1584 14.3437C26.1584 14.5677 26.0694 14.7826 25.9109 14.9411C25.7525 15.0995 25.5376 15.1885 25.3136 15.1885C25.0895 15.1885 24.8746 15.0995 24.7162 14.9411L13.5011 3.72425L2.28594 14.9411C2.12751 15.0995 1.91262 15.1885 1.68857 15.1885C1.46451 15.1885 1.24962 15.0995 1.09119 14.9411C0.932757 14.7826 0.84375 14.5677 0.84375 14.3437C0.84375 14.1196 0.932757 13.9047 1.09119 13.7463L12.308 2.53119Z"
						fill="currentColor"
					/>
				</svg>
			</button>

			<!-- 2. Студенты -->
			<button
				v-if="showUsersSection"
				:class="['admn_nav-item', { active: activeMenu === 2 }]"
				@click="setActiveMenu(2)"
				title="Студенты"
			>
				<svg width="28" height="22" viewBox="0 0 32 24" fill="none">
					<path
						d="M5.75977 14.7139H5.94727C7.05552 15.2454 8.28152 15.5712 9.59961 15.5713C10.9169 15.5713 12.1484 15.2464 13.2549 14.7139H13.4404C16.0041 14.7141 18.2002 16.9649 18.2002 19.8857V21.4287C18.2001 22.3621 17.5086 23 16.7998 23H2.40039C1.69157 23 1.00007 22.3621 1 21.4287V19.8857L1.00684 19.6143C1.13791 16.8266 3.27603 14.714 5.75977 14.7139ZM21.5996 14.7139H21.6182C22.3453 14.9668 23.1409 15.1426 24 15.1426C24.8591 15.1426 25.6547 14.9668 26.3818 14.7139H26.4004C28.879 14.7141 30.9998 16.8843 31 19.7139C31 20.6473 30.3085 21.2861 29.5996 21.2861H21.7998V19.8857C21.7998 18.0417 21.2555 16.3371 20.3438 14.9199C20.747 14.7873 21.1664 14.7139 21.5996 14.7139ZM9.59961 1C12.0785 1 14.2002 3.17011 14.2002 6C14.2002 8.82989 12.0785 11 9.59961 11C7.12092 10.9998 5 8.82974 5 6C5 3.17026 7.12092 1.00023 9.59961 1ZM24 2.71387C26.0339 2.71387 27.7998 4.50432 27.7998 6.85742C27.7997 9.21039 26.0338 11 24 11C21.9662 11 20.2003 9.21039 20.2002 6.85742C20.2002 4.50432 21.9661 2.71387 24 2.71387Z"
						stroke="currentColor"
						stroke-width="2"
					/>
				</svg>
			</button>

			<!-- 3. Преподаватели -->
			<button
				v-if="showUsersSection"
				:class="['admn_nav-item', { active: activeMenu === 3 }]"
				@click="setActiveMenu(3)"
				title="Преподаватели"
			>
				<svg width="22" height="22" viewBox="0 0 25 25" fill="none">
					<path
						d="M18.9302 17.0501C19.8204 16.5003 20.9897 17.1001 20.9897 18.0997V19.7115C20.9897 21.2984 19.6743 22.9977 18.0931 23.4975L13.8545 24.822C13.1104 25.0594 11.9012 25.0594 11.1704 24.822L6.93178 23.4975C5.33731 22.9977 4.03516 21.2984 4.03516 19.7115V18.0872C4.03516 17.1001 5.20443 16.5003 6.08139 17.0376L8.81857 18.7119C9.86828 19.3742 11.197 19.699 12.5257 19.699C13.8545 19.699 15.1832 19.3742 16.2329 18.7119L18.9302 17.0501Z"
						fill="currentColor"
					/>
					<path
						d="M23.1165 5.57589L15.1574 0.665358C13.7224 -0.221786 11.3572 -0.221786 9.92222 0.665358L1.92333 5.57589C-0.64111 7.13776 -0.64111 10.6739 1.92333 12.2482L4.04929 13.5477L9.92222 17.1463C11.3572 18.0334 13.7224 18.0334 15.1574 17.1463L20.9905 13.5477L22.8109 12.4232V16.2466C22.8109 16.7589 23.2626 17.1838 23.8074 17.1838C24.3522 17.1838 24.8039 16.7589 24.8039 16.2466V10.0991C25.3354 8.48722 24.7907 6.61297 23.1165 5.57589Z"
						fill="currentColor"
					/>
				</svg>
			</button>

			<!-- 4. Курсы -->
			<button
				v-if="showCoursesSection"
				:class="['admn_nav-item', { active: activeMenu === 4 }]"
				@click="setActiveMenu(4)"
				title="Курсы"
			>
				<svg width="20" height="20" viewBox="0 0 23 23" fill="none">
					<path
						d="M21.1719 2.78906C21.875 2.75 22.5 3.29688 22.4609 3.96094V17.1641C22.4609 17.7891 21.9531 18.3359 21.2891 18.375C19.375 18.4531 15.4688 18.8438 12.7734 20.2109C12.3438 20.4062 11.8359 20.1328 11.8359 19.6641V5.44531C11.8359 5.25 11.9531 5.05469 12.1484 4.9375C14.7656 3.33594 19.0234 2.90625 21.1719 2.78906ZM10.3125 4.9375C10.5078 5.05469 10.625 5.25 10.625 5.44531V19.6641C10.625 20.1328 10.1172 20.4062 9.6875 20.2109C6.99219 18.8438 3.08594 18.4531 1.17188 18.375C0.507812 18.3359 0 17.7891 0 17.1641V3.96094C0 3.29688 0.585938 2.75 1.28906 2.78906C3.4375 2.90625 7.69531 3.33594 10.3125 4.9375Z"
						fill="currentColor"
					/>
				</svg>
			</button>

			<!-- 5. Аналитика -->
			<button
				v-if="showAnalyticsSection"
				:class="['admn_nav-item', { active: activeMenu === 5 }]"
				@click="setActiveMenu(5)"
				title="Аналитика"
			>
				<svg width="22" height="17" viewBox="0 0 25 19" fill="none">
					<path
						d="M16.25 12.5H18.125C18.4375 12.5 18.75 12.1875 18.75 11.875V5.3125C18.75 5 18.4375 4.6875 18.125 4.6875H16.25C15.9375 4.6875 15.625 5 15.625 5.3125V11.875C15.625 12.1875 15.9375 12.5 16.25 12.5ZM20.9375 12.5H22.8125C23.125 12.5 23.4375 12.1875 23.4375 11.875V0.625C23.4375 0.3125 23.125 0 22.8125 0H20.9375C20.625 0 20.3125 0.3125 20.3125 0.625V11.875C20.3125 12.1875 20.625 12.5 20.9375 12.5ZM6.875 12.5H8.75C9.0625 12.5 9.375 12.1875 9.375 11.875V8.4375C9.375 8.125 9.0625 7.8125 8.75 7.8125H6.875C6.5625 7.8125 6.25 8.125 6.25 8.4375V11.875C6.25 12.1875 6.5625 12.5 6.875 12.5ZM11.5625 12.5H13.4375C13.75 12.5 14.0625 12.1875 14.0625 11.875V2.1875C14.0625 1.875 13.75 1.5625 13.4375 1.5625H11.5625C11.25 1.5625 10.9375 1.875 10.9375 2.1875V11.875C10.9375 12.1875 11.25 12.5 11.5625 12.5ZM24.2188 15.625H3.125V0.78125C3.125 0.349609 2.77539 0 2.34375 0H0.78125C0.349609 0 0 0.349609 0 0.78125V17.1875C0 18.0503 0.699707 18.75 1.5625 18.75H24.2188C24.6504 18.75 25 18.4004 25 17.9688V16.4062C25 15.9746 24.6504 15.625 24.2188 15.625Z"
						fill="currentColor"
					/>
				</svg>
			</button>

			<!-- 6. Настройки -->
			<button
				v-if="showSettingsSection"
				:class="['admn_nav-item', { active: activeMenu === 7 }]"
				@click="setActiveMenu(7)"
				title="Настройки"
			>
				<svg width="24" height="24" viewBox="0 0 30 30" fill="none">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12.5008 2.5C11.8105 2.5 11.2508 3.05965 11.2508 3.75V5.72722C10.3817 6.07897 9.5739 6.54904 8.84715 7.11706L7.13301 6.12741C6.84591 5.96165 6.50471 5.91672 6.18449 6.00252C5.86426 6.08834 5.59125 6.29784 5.42549 6.58494L2.92549 10.9151C2.58031 11.5129 2.78515 12.2774 3.38301 12.6226L5.09653 13.6119C5.03339 14.066 5.00081 14.5295 5.00081 15C5.00081 15.4705 5.03339 15.9339 5.09653 16.3881L3.38303 17.3774C3.09591 17.5431 2.88643 17.8161 2.80061 18.1364C2.71481 18.4566 2.75973 18.7977 2.92549 19.0849L5.42549 23.415C5.59125 23.7021 5.86428 23.9116 6.1845 23.9975C6.50473 24.0832 6.84591 24.0384 7.13303 23.8726L8.84718 22.8829C9.57393 23.4509 10.3818 23.921 11.2508 24.2727V26.25C11.2508 26.9404 11.8105 27.5 12.5008 27.5H17.5009C18.1911 27.5 18.7509 26.9404 18.7509 26.25V24.2727C19.6199 23.921 20.4277 23.4509 21.1545 22.8829L22.8686 23.8726C23.1557 24.0384 23.4969 24.0832 23.8171 23.9975C24.1374 23.9116 24.4104 23.7021 24.5761 23.4151L27.0761 19.085C27.2419 18.7979 27.2869 18.4566 27.201 18.1364C27.1152 17.8162 26.9057 17.5431 26.6186 17.3774L24.9051 16.3881C24.9682 15.934 25.0009 15.4705 25.0009 15C25.0009 14.5295 24.9682 14.066 24.9051 13.6119L26.6186 12.6226C27.2165 12.2774 27.4214 11.5129 27.0761 10.915L24.5761 6.58491C24.4104 6.2978 24.1374 6.08831 23.8171 6.0025C23.4969 5.9167 23.1557 5.96161 22.8686 6.12737L21.1545 7.11705C20.4277 6.54903 19.6199 6.07897 18.7509 5.72722V3.75C18.7509 3.05965 18.1911 2.5 17.5009 2.5H12.5008ZM13.7509 6.61232V5H16.2509V6.61232C16.2509 7.16535 16.6142 7.65264 17.1442 7.81039C18.2831 8.14934 19.3102 8.75247 20.1537 9.55036C20.5554 9.9303 21.1589 10.0012 21.6377 9.7248L23.0361 8.91744L24.2861 11.0825L22.8895 11.8888C22.411 12.1651 22.1706 12.7226 22.2982 13.2601C22.4305 13.8172 22.5009 14.3996 22.5009 15C22.5009 15.6004 22.4305 16.1827 22.2982 16.7399C22.1706 17.2774 22.411 17.8349 22.8895 18.1111L24.2861 18.9175L23.0361 21.0825L21.6376 20.2751C21.1589 19.9987 20.5554 20.0696 20.1536 20.4496C19.3102 21.2475 18.2831 21.8506 17.1442 22.1895C16.6142 22.3472 16.2509 22.8346 16.2509 23.3876V25H13.7509V23.3876C13.7509 22.8346 13.3874 22.3472 12.8574 22.1895C11.7185 21.8506 10.6914 21.2475 9.84794 20.4496C9.44629 20.0696 8.84275 19.9987 8.36395 20.2751L6.96555 21.0825L5.71555 18.9175L7.11216 18.1111C7.5906 17.8349 7.83096 17.2774 7.70336 16.7399C7.57111 16.1827 7.50081 15.6004 7.50081 15C7.50081 14.3996 7.5711 13.8172 7.70336 13.2601C7.83096 12.7226 7.59059 12.1651 7.11216 11.8889L5.71555 11.0825L6.96555 8.91747L8.36393 9.72482C8.84274 10.0013 9.44626 9.93031 9.84793 9.55037C10.6914 8.75249 11.7185 8.14935 12.8574 7.81039C13.3874 7.65264 13.7509 7.16535 13.7509 6.61232ZM12.5008 15C12.5008 13.6192 13.6201 12.5 15.0009 12.5C16.3816 12.5 17.5009 13.6192 17.5009 15C17.5009 16.3807 16.3816 17.5 15.0009 17.5C13.6201 17.5 12.5008 16.3807 12.5008 15ZM15.0009 10C12.2394 10 10.0008 12.2386 10.0008 15C10.0008 17.7614 12.2394 20 15.0009 20C17.7622 20 20.0009 17.7614 20.0009 15C20.0009 12.2386 17.7622 10 15.0009 10Z"
						fill="currentColor"
					/>
				</svg>
			</button>
		</nav>

		<!-- Разделитель снизу -->
		<div class="admn_sidebar-divider admn_sidebar-divider--bottom"></div>

		<!-- Кнопка выхода -->
		<button class="admn_logout-btn" @click="handleLogout" title="Выйти">
			<svg width="20" height="17" viewBox="0 0 20 17" fill="none">
				<path
					d="M19.4141 9.16406L12.8516 15.7266C12.2656 16.3125 11.25 15.9219 11.25 15.0625V11.3125H5.9375C5.39062 11.3125 5 10.9219 5 10.375V6.625C5 6.11719 5.39062 5.6875 5.9375 5.6875H11.25V1.9375C11.25 1.11719 12.2266 0.6875 12.8516 1.27344L19.4141 7.83594C19.7656 8.22656 19.7656 8.8125 19.4141 9.16406ZM7.5 15.5312C7.5 15.8047 7.26562 16 7.03125 16H3.75C1.67969 16 0 14.3203 0 12.25V4.75C0 2.67969 1.67969 1 3.75 1H7.03125C7.26562 1 7.5 1.23438 7.5 1.46875V3.03125C7.5 3.30469 7.26562 3.5 7.03125 3.5H3.75C3.04688 3.5 2.5 4.08594 2.5 4.75V12.25C2.5 12.9531 3.04688 13.5 3.75 13.5H7.03125C7.26562 13.5 7.5 13.7344 7.5 13.9688V15.5312Z"
					fill="currentColor"
				/>
			</svg>
		</button>
	</aside>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// Получаем activeMenu и setActiveMenu из родительского компонента
const activeMenu = inject('activeMenu')
const setActiveMenu = inject('setActiveMenu')
const canViewDashboardSection = inject('canViewDashboardSection', null)
const showDashboardSection = computed(() => canViewDashboardSection?.value !== false)
const canViewUsersSection = inject('canViewUsersSection', null)
const showUsersSection = computed(() => canViewUsersSection?.value !== false)
const canViewCoursesSection = inject('canViewCoursesSection', null)
const showCoursesSection = computed(() => canViewCoursesSection?.value !== false)
const canViewAnalyticsSection = inject('canViewAnalyticsSection', null)
const showAnalyticsSection = computed(() => canViewAnalyticsSection?.value !== false)
const canViewSettingsSection = inject('canViewSettingsSection', null)
const showSettingsSection = computed(() => canViewSettingsSection?.value !== false)

/**
 * Обработчик выхода из системы
 */
const handleLogout = async () => {
	try {
		const { authService } = await import('@/services/auth')
		const { useAppStore } = await import('@/stores/useAppStore')
		const appStore = useAppStore()

		console.log('🔍 [AdminSidebar] Logging out...')
		await authService.logout()
		console.log('✅ [AdminSidebar] Logout successful')

		appStore.showSuccess('Вы успешно вышли из системы')
		router.push('/auth')
	} catch (error) {
		console.error('❌ [AdminSidebar] Logout error:', error)

		const { useAppStore } = await import('@/stores/useAppStore')
		const appStore = useAppStore()
		appStore.showError('Ошибка при выходе из системы')
	}
}
</script>

<style scoped>
.admn_sidebar-collapsed {
	position: fixed;
	top: 10px;
	left: 20px;
	bottom: 10px;
	width: var(--admin-sidebar-collapsed-width, 93px);
	background-color: rgba(17, 24, 40, 0.9);
	border-radius: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px 0;
	z-index: 1000;
	box-shadow: 0 18px 47px rgba(47, 50, 125, 0.1);
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Логотип */
.admn_sidebar-logo {
	width: 60px;
	height: 60px;
	flex-shrink: 0;
	margin-bottom: 16px;
}

.admn_sidebar-logo img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

/* Разделители */
.admn_sidebar-divider {
	width: 80%;
	height: 1px;
	background: rgba(255, 255, 255, 0.1);
	flex-shrink: 0;
}

.admn_sidebar-divider--bottom {
	margin-top: auto;
	margin-bottom: 16px;
}

/* Навигация */
.admn_sidebar-nav {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	padding: 24px 0;
	width: 100%;
	flex: 1;
}

/* Элемент навигации */
.admn_nav-item {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 50px;
	border-radius: 12px;
	border: none;
	background: transparent;
	color: rgba(255, 255, 255, 0.7);
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
}


.admn_nav-item.active {
	background: #2563ea;
	color: #ffffff;
	box-shadow: 0 4px 15px rgba(37, 99, 234, 0.4);
}

.admn_nav-item.active::before {
	height: 30px;
}

.admn_nav-item svg {
	transition: transform 0.2s ease;
}

.admn_nav-item:hover svg {
	transform: scale(1.1);
}

.admn_nav-item:active svg {
	transform: scale(0.95);
}

/* Кнопка выхода */
.admn_logout-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border-radius: 10px;
	border: none;
	background: rgba(255, 93, 93, 0.1);
	color: #ff5d5d;
	cursor: pointer;
	transition: all 0.3s ease;
	flex-shrink: 0;
}

.admn_logout-btn:hover {
	background: rgba(255, 93, 93, 0.2);
	transform: scale(1.05);
}

.admn_logout-btn:active {
	transform: scale(0.95);
}

/* Tooltip для кнопок */
.admn_nav-item[title]:hover::after,
.admn_logout-btn[title]:hover::after {
	content: attr(title);
	position: absolute;
	left: calc(100% + 12px);
	top: 50%;
	transform: translateY(-50%);
	background: #1e293b;
	color: #ffffff;
	padding: 6px 12px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 500;
	white-space: nowrap;
	z-index: 1001;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	animation: tooltip-fade-in 0.2s ease;
}


/* Для logout кнопки исключаем стандартный ::before */
.admn_logout-btn[title]:hover::before {
	content: '';
	position: absolute;
	left: calc(100% + 4px);
	top: 50%;
	transform: translateY(-50%);
	border: 6px solid transparent;
	border-right-color: #1e293b;
	width: 0;
	height: 0;
	background: transparent;
	border-radius: 0;
}

@keyframes tooltip-fade-in {
	from {
		opacity: 0;
		transform: translateY(-50%) translateX(-5px);
	}
	to {
		opacity: 1;
		transform: translateY(-50%) translateX(0);
	}
}

/* Адаптивность */
@media (max-height: 700px) {
	.admn_sidebar-nav {
		gap: 8px;
		padding: 16px 0;
	}
	
	.admn_nav-item {
		width: 44px;
		height: 44px;
	}
	
	.admn_sidebar-logo {
		width: 48px;
		height: 48px;
	}
}

@media (max-width: 768px) {
	.admn_sidebar-collapsed {
		display: none;
	}
}
</style>
